import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Table } from '../../common/table'
import { ButtonBack } from '../../library/common/html/button/ButtonBack'
import { COMPONENTS } from '../../routers/constants'
import '../i18n'
import {
  selectCellDataById,
  selectLoadingByKey,
  selectUserSettings,
} from '../store/slice'
import { getUserNotificationSettings } from '../store/thunk'
import Header from '../viewAll/Header'
import Layout from '../viewAll/Layout'
import useSchema from './useSchema'

export const SystemNotificationsSettings = () => {
  const dispatch = useDispatch()
  const schema = useSchema()

  const locale = useSelector((state) => state.i18n.locale)
  const isLoading = useSelector(selectLoadingByKey('userNotificationsSettings'))
  const userNotificationsSettings = useSelector(selectUserSettings)

  useEffect(() => {
    dispatch(getUserNotificationSettings())
  }, [locale])

  return (
    <Layout>
      <ButtonBack
        text="systemNotificationsSettings.BACK_TO_SYSTEM_NOTIFICATIONS"
        linkTo={COMPONENTS.systemNotifications.route}
        wrapStyle={{ marginBottom: 0 }}
      />
      <Header />
      <Table
        ids={Object.keys(userNotificationsSettings)}
        getDataFromRedux={selectCellDataById}
        schema={schema}
        noDataText="common.NO_DATA"
        isLoading={isLoading}
      />
    </Layout>
  )
}

export default SystemNotificationsSettings
